import {
  REORDER_AREA_ENTRY_STRATEGY,
  REORDER_AREA_ENTRY_STRATEGY_SUCCESSFUL,
  REORDER_AREA_ENTRY_STRATEGY_FAILED,
} from './actionTypes';

const initialState = {
  reorderAreaEntryStrategyError: null,
  messageReorderAreaEntryStrategy: null,
  loadingReorderAreaEntryStrategy: false,
};

const reorderAreaEntryStrategy = (state = initialState, action) => {
  switch (action.type) {
    case REORDER_AREA_ENTRY_STRATEGY:
      state = {
        ...state,
        loadingReorderAreaEntryStrategy: true,
        reorderAreaEntryStrategyError: null,
      };
      break;
    case REORDER_AREA_ENTRY_STRATEGY_FAILED:
      state = {
        ...state,
        messageReorderAreaEntryStrategy: null,
        loadingReorderAreaEntryStrategy: false,
        reorderAreaEntryStrategyError: action.payload,
      };
      break;
    case REORDER_AREA_ENTRY_STRATEGY_SUCCESSFUL:
      state = {
        ...state,
        loadingReorderAreaEntryStrategy: false,
        messageReorderAreaEntryStrategy: action.payload,
        reorderAreaEntryStrategyError: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default reorderAreaEntryStrategy;
